import moment from 'moment';

export const formatDate = (date: Date, language?: string) => {
  moment.locale(language);
  const formattedDate = moment(date).format('MMMM D');
  console.log(formattedDate);
  return formattedDate.charAt(0).toUpperCase() + formattedDate.slice(1).toLowerCase();
};
